import { InputSelectProps } from '@dirootie-web/components-types';
import { InputSelect } from '@components-common/forms';

export type SelectSystemEnumProps = Omit<InputSelectProps, "options"|"formState"|"id"> & Partial<Pick<InputSelectProps, "id">>;

export const SelectSystemEnum = (
  props: { options?: any, items?:any[] } & Omit<InputSelectProps, "items" | "options"|"formState">
) => {
  const {options = undefined, items = undefined, ...rest} = props;
  const newProps = {options, items, ...rest};
  return <InputSelect {...newProps} />;
};
